import React, { useState } from "react";
import axios from "axios";
import ForgotPasswordModal from "./modals/ForgotPasswordModal";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Login.css";

const Login = ({ onLoginSuccess }) => {
  const [accessKey, setAccessKey]   = useState("");
  const [secretKey, setSecretKey]   = useState("");
  const [error, setError]           = useState("");
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [showPassword, setShowPassword]       = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!accessKey) {
      setError("required-access");
      return;
    }
    if (!secretKey) {
      setError("required-secret");
      return;
    }
    try {
      const { data } = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/api/auth/login`,
        { username: accessKey, password: secretKey }
      );
      localStorage.setItem("token", data.token);
      axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
      localStorage.setItem("username", data.username);
      onLoginSuccess && onLoginSuccess(data);
      window.location.href = "/dashboard";
    } catch (err) {
      setError("Credenciais inválidas");
    }
  };

   return (
    <main className="vd-login-bg" role="main">
      {/* Vídeo de fundo */}
      <video autoPlay loop muted playsInline className="vd-login-bg-video" aria-hidden="true">
        <source src="/intro.mp4" type="video/mp4" />
      </video>

      {/* Overlay escuro para contraste */}
      <div className="vd-login-overlay" />

      {/* Card de login */}
      <section className="vd-login-card" aria-label="Acessar conta">
        <div className="vd-logo-wrapper mb-3">
          <img
            src="/logo_viadrive_white.svg"
            alt="Viadrive"
            className="vd-login-logo"
            loading="eager"
          />
        </div>

        <div className="vd-login-title">
          <span className="vd-login-title-sub">Faça login para continuar.</span>
        </div>

        <form className="vd-login-form" onSubmit={handleSubmit} autoComplete="off">
          <div className="vd-form-group">
            <label className="vd-label" htmlFor="vd-user">Usuário</label>
            <input
              id="vd-user"
              type="text"
              placeholder="Seu usuário ou e-mail"
              className={`vd-input ${error === "required-access" ? "vd-error" : ""}`}
              value={accessKey}
              onChange={e => setAccessKey(e.target.value)}
              autoCapitalize="none"
              autoCorrect="off"
              inputMode="email"
              autoComplete="username"
              aria-invalid={error === "required-access"}
            />
            {error === "required-access" && (
              <div className="vd-error-label">Campo obrigatório</div>
            )}
          </div>

          <div className="vd-form-group">
            <label className="vd-label" htmlFor="vd-pass">Senha</label>
            <div className="vd-password-wrapper">
              <input
                id="vd-pass"
                type={showPassword ? "text" : "password"}
                placeholder="Senha"
                className={`vd-input ${error === "required-secret" ? "vd-error" : ""}`}
                value={secretKey}
                onChange={e => setSecretKey(e.target.value)}
                autoComplete="current-password"
                aria-invalid={error === "required-secret"}
              />
              <button
                type="button"
                className="vd-password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {error === "required-secret" && (
              <div className="vd-error-label">Campo obrigatório</div>
            )}
          </div>

          {error && error !== "required-access" && error !== "required-secret" && (
            <div className="vd-error-label text-center mb-2">{error}</div>
          )}

          <button type="submit" className="vd-login-btn">
            Entrar
          </button>
        </form>

        <div className="text-end mt-3">
          <a
            href="#"
            className="vd-forgot-link"
            onClick={e => { e.preventDefault(); setShowForgotModal(true); }}
          >
            Esqueceu sua senha?
          </a>
        </div>

        <div className="vd-login-desc mb-3">
          Ainda não tem uma conta?{" "}
          <button
            type="button"
            className="vd-signup-link"
            onClick={() => (window.location.href = "/register")}
          >
            Cadastre-se aqui
          </button>
          <br />
          <span className="vd-signup-note">Leva menos de um minuto.</span>
        </div>

        <ForgotPasswordModal
          show={showForgotModal}
          onClose={() => setShowForgotModal(false)}
        />
      </section>
    </main>
  );
};

export default Login;
